import React from "react";
import { EnableLutSwitch } from "../../../../Account/modules/EnableLutModal/modules/EnableLutSwitch/EnableLutSwitch";
import { FEATURE_STATUS } from "features/Account/Account.constants";
import { DocumentUploadedNote } from "../../../../Account/modules/EnableLutModal/modules/DocumentUploadedNote/DocumentUploadedNote";
import { CreditCardSubSection } from "../../../../Account/modules/PaymentOptions/modules/CreditCardSubSection/CreditCardSubSection";
import { EnableInternationalPaymentSwitch } from "features/Account/modules/PaymentOptions/modules/InternationalPayment/EnableInternationalPaymentSwitch.jsx";
import { InternationalPaymentFooter } from "features/Account/modules/PaymentOptions/modules/InternationalPayment/InternationalPaymentFooter";

export const PAYMENT_OPTION_KEYS = {
  EMI: "emi",
  NO_COST_EMI: "no_cost_emi",
  CUSTOMER_REFUND: "customer_refund",
  INTERNATIONAL_PAYMENT: "international_payment",
  LUT: "lut",
  CREDIT_CARD: "credit_cards",
  AMEX_CARD: "amex_cards",
  DINERS_CARD: "diner_cards",
};
export const PAYMENT_OPTIONS_CONFIG = [
  {
    title: "EMI Customer Payments",
    description:
      "Allow customers to split their payments into manageable monthly instalments. **Standard 4-5% rate applicable**.",
    subSectionConfig: [
      {
        key: PAYMENT_OPTION_KEYS.EMI,
        title: "Enable EMI payments",
        description:
          "Toggle on to start accepting EMI payments from customers.",
      },
    ],
  },
  {
    title: "No-cost EMI Customer Payments",
    description:
      "Offer EMI plans with zero interest or fees, a cost-effective payment option. **Standard 4-5% rate applicable**.",
    subSectionConfig: [
      {
        key: PAYMENT_OPTION_KEYS.NO_COST_EMI,
        title: "Enable No-cost EMI payments",
        description:
          "Toggle on to start accepting zero interest EMI payments from customers.",
      },
    ],
  },
  {
    title: "International Customer Payments",
    description:
      "Accept payments from international customers and expand globally.",
    subSectionConfig: [
      {
        key: PAYMENT_OPTION_KEYS.INTERNATIONAL_PAYMENT,
        title: "Collect international payments",
        description:
          "Toggle on to start accepting payments from international customers.",
        customRightJSX: <EnableInternationalPaymentSwitch />,
        customFooter: <InternationalPaymentFooter />,
      },
      {
        key: PAYMENT_OPTION_KEYS.LUT,
        title: "Exempt customers from GST",
        description:
          "Provide the GST certificate and Letter of Undertaking to disable GST application for international customers.",
        customRightJSX: <EnableLutSwitch />,
        lockedStatesArr: [FEATURE_STATUS.PLAN_LOCKED],
        customFooter: (
          <DocumentUploadedNote text="Documents have been uploaded successfully. We’ll notify you once it has been activated." />
        ),
      },
    ],
  },
  {
    title: "Accept Credit Card Payments",
    description:
      "Allow customers to pay using their credit cards for added convenience and higher-value purchases.",
    subSection: <CreditCardSubSection />,
  },
];

export const DURATIONS = [3, 6, 9, 12];

export const EMI_DURATION_OPTIONS = DURATIONS.map((m) => ({
  label: `${m} months`,
  value: m,
}));

export const DEBOUNCE_DELAY = 1000;
